/* eslint-disable-next-line @typescript-eslint/no-restricted-imports --
 * Wrapper around transaction for experiment   */
import { transaction as mobxTransaction } from "mobx";

export function transaction<T>(action: () => T): T {
    return mobxTransaction(action);
}
